/**
 * Contains default styles for using the InpulseLabel in the ListView
 *
 * Values are taken from legacy code.
 */

export const labelContainerStyle = {
  minWidth: '115px',
  marginLeft: '2px',
  padding: '5px 0px',
};

export const labelInAdvancedFilterStyle = {
  padding: '0',
  border: 'none',
  backgroundColor: 'transparent',
};
